<template>
  <div class="schedule">
    <div class="schedule__title">Horario de atención</div>

    <div v-if="getDays === null" class="schedule__note">Cargando horario…</div>
    <div v-else-if="getDays.length === EMPTY" class="schedule__note">
      Esta cocina no tiene horario registrado
    </div>
    <table v-else class="schedule__table">
      <tbody>
        <tr
          v-for="day in getDays"
          :key="day.day_number"
          :class="{ 'schedule__row--today': isToday(day.day_number) }"
        >
          <td class="schedule__day">
            {{ dayName(day.day_number) }}
            <span v-if="isToday(day.day_number)" class="schedule__today">hoy</span>
          </td>
          <td class="schedule__hours">
            <template v-if="day.is_open">{{ day.hour_start }} – {{ day.hour_end }}</template>
            <template v-else>Cerrado</template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

const EMPTY = 0;
const WEEK_DAYS = {
  1: 'Lunes',
  2: 'Martes',
  3: 'Miércoles',
  4: 'Jueves',
  5: 'Viernes',
  6: 'Sábado',
  7: 'Domingo'
};

export default {
  name: 'ScheduleTable',
  data() {
    return { EMPTY };
  },
  computed: {
    ...mapGetters('foodcourtSchedule', ['getDays']),
    todayNumber() {
      return moment().isoWeekday();
    }
  },
  methods: {
    dayName(dayNumber) {
      return WEEK_DAYS[dayNumber] || '';
    },
    isToday(dayNumber) {
      return dayNumber === this.todayNumber;
    }
  }
};
</script>

<style scoped>
.schedule {
  margin-top: 1.5rem;
}
.schedule__title {
  font-size: 11px;
  font-weight: 600;
  color: #737373;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 12px;
}
.schedule__note {
  font-size: 0.82rem;
  font-style: italic;
  color: #8a988f;
}
.schedule__table {
  width: 100%;
  max-width: 420px;
}
.schedule__table tr {
  border-bottom: 1px solid #f0f0f0;
}
.schedule__row--today {
  background: #e8f5ec;
}
.schedule__day {
  padding: 8px 12px;
  font-size: 0.85rem;
  color: #171717;
  width: 55%;
}
.schedule__today {
  margin-left: 8px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #01662e;
  background: #fff;
  border-radius: 6px;
  padding: 2px 7px;
}
.schedule__hours {
  padding: 8px 12px;
  font-size: 0.85rem;
  color: #737373;
  font-variant-numeric: tabular-nums;
  text-align: right;
}
</style>
